// --- Shared activity type mapping tables ---
// Used by both case and promise recent activity GraphQL hooks.

/**
 * Maps a GraphQL activityType string to a UI tag category.
 * The tag type is compatible with both CaseUnifiedActivity["tag"] and PromiseUnifiedActivity["tag"].
 */
export const ACTIVITY_TYPE_TO_TAG: Record<string, "Note" | "Communication" | "Activity"> = {
  note: "Note",
  email: "Communication",
  phone: "Communication",
  sms: "Communication",
  communication: "Communication",
  promise: "Activity",
  status_change: "Activity",
  payment: "Activity",
  system: "Activity",
  case: "Activity",
  dispute: "Activity",
};

/**
 * Maps a GraphQL activityType string to a specific UI activity type.
 * The type is compatible with both CaseUnifiedActivity["type"] and PromiseUnifiedActivity["type"].
 */
export const ACTIVITY_TYPE_TO_TYPE: Record<string, string> = {
  email: "email",
  phone: "call",
  sms: "sms",
  communication: "communication",
  note: "note",
  promise: "promise",
  payment: "payment",
  status_change: "status_change",
  system: "system",
  case: "case_note",
  dispute: "dispute",
};

/**
 * Parse the outcome field from activity metadata JSON.
 */
export function parseActivityOutcome(metadataJson: string | null): string | undefined {
  if (!metadataJson) return undefined;
  try {
    const metadata = JSON.parse(metadataJson) as Record<string, unknown>;
    if (typeof metadata.outcome === "string") {
      return metadata.outcome;
    }
  } catch {
    // ignore malformed metadata
  }
  return undefined;
}
